import React from 'react'

export const StepTypes = {
  cssSelector: 'css_selector',
  click: 'click',
  input: 'input',
  dropdownSelect: 'dropdown_select',
  goto: 'goto',
  copyPaste: 'copy_paste',
  highlighting: 'highlighting',
  textOnly: 'text_only',
  inputText: 'input_text',
  media: 'media',
  video: 'video',
  ensureSelector: 'ensure_selector',
  section: 'section',
}

export const ClickIcon = () => (
  <svg width="14" height="16" viewBox="0 0 14 16" fill="none" xmlns="http://www.w3.org/2000/svg">
    <path
      d="M2.84674 14.5059C3.16245 14.8221 3.53755 15.0726 3.95048 15.2432C4.3634 15.4138 4.80598 15.5011 5.25276 15.5H9.38983C9.8366 15.5011 10.2792 15.4138 10.6921 15.2432C11.105 15.0726 11.4801 14.8221 11.7958 14.5059C13.7478 12.5622 13.5003 10.2871 13.7832 9.11098C13.8802 8.43409 13.7685 7.74373 13.4632 7.1319C13.1578 6.52007 12.6732 6.01583 12.074 5.68638C10.9341 5.04618 9.87935 5.35298 7.70377 5.27322V2.62175C7.70979 2.12755 7.54168 1.64699 7.22892 1.26429C6.91615 0.881597 6.47868 0.621179 5.99318 0.528675C5.69961 0.479037 5.39876 0.493977 5.11157 0.572455C4.82437 0.650933 4.55772 0.791063 4.3302 0.98309C4.10267 1.17512 3.91974 1.41443 3.79412 1.68435C3.6685 1.95428 3.60323 2.24835 3.60284 2.54608V9.48801C3.25243 9.18398 2.81139 9.00425 2.34829 8.97676C1.88518 8.94926 1.42597 9.07554 1.04205 9.33597C0.799711 9.50847 0.597911 9.73176 0.450725 9.99026C0.303539 10.2488 0.21451 10.5363 0.189844 10.8327C0.165178 11.1291 0.20547 11.4274 0.307911 11.7067C0.410351 11.9859 0.572474 12.2395 0.782975 12.4497L2.84674 14.5059ZM1.83701 10.4439C1.9841 10.3554 2.15708 10.3201 2.32707 10.3438C2.49706 10.3675 2.65377 10.4488 2.77106 10.5741L3.80328 11.6029C3.89875 11.6981 4.02028 11.7628 4.15253 11.7889C4.28477 11.815 4.42179 11.8014 4.54627 11.7496C4.67075 11.6979 4.7771 11.6104 4.85188 11.4983C4.92666 11.3861 4.96651 11.2543 4.96641 11.1195V2.54608C4.96665 2.44744 4.9883 2.35003 5.02985 2.26057C5.0714 2.17111 5.13187 2.09174 5.20708 2.02792C5.28445 1.96205 5.37541 1.91409 5.47347 1.88745C5.57153 1.86082 5.67426 1.85617 5.77432 1.87384C5.94059 1.91455 6.08771 2.01141 6.19081 2.14805C6.29392 2.28469 6.34669 2.45274 6.3402 2.6238V5.955C6.3402 6.13582 6.41203 6.30924 6.53989 6.4371C6.66775 6.56495 6.84117 6.63679 7.02199 6.63679C10.1418 6.69951 10.7036 6.48202 11.4065 6.87541C11.7656 7.07131 12.0563 7.37207 12.2399 7.73754C12.4235 8.10301 12.4912 8.51579 12.434 8.92076C12.1538 10.148 12.3931 11.9888 10.8338 13.5433C10.6441 13.7324 10.4188 13.8821 10.171 13.9839C9.92321 14.0857 9.65773 14.1375 9.38983 14.1364H5.25276C4.98462 14.1371 4.719 14.0847 4.47117 13.9823C4.22335 13.88 3.99822 13.7296 3.80874 13.5399L1.74566 11.4836C1.67543 11.4132 1.62145 11.3283 1.58752 11.2348C1.55359 11.1413 1.54051 11.0415 1.54922 10.9425C1.55792 10.8434 1.58819 10.7474 1.63791 10.6613C1.68763 10.5752 1.75558 10.501 1.83701 10.4439Z"
      fill="#EA6A29"
    />
  </svg>
)

export const DropdownIcon = () => (
  <svg width="16" height="16" viewBox="0 0 16 16" fill="none" xmlns="http://www.w3.org/2000/svg">
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M5.02272 1.33625C5.28632 1.07265 5.71371 1.07265 5.97731 1.33625L8.00001 3.35896L10.0227 1.33625C10.2863 1.07265 10.7137 1.07265 10.9773 1.33625C11.2409 1.59986 11.2409 2.02724 10.9773 2.29085L8.83086 4.43729C8.372 4.89616 7.62803 4.89616 7.16916 4.43729L5.02272 2.29085C4.75911 2.02724 4.75911 1.59986 5.02272 1.33625Z"
      fill="#EA6A29"
    />
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M1.5 7.46143C1.5 7.08588 1.80445 6.78143 2.18 6.78143H13.82C14.1956 6.78143 14.5 7.08588 14.5 7.46143C14.5 7.83699 14.1956 8.14143 13.82 8.14143H2.18C1.80445 8.14143 1.5 7.83699 1.5 7.46143Z"
      fill="#EA6A29"
    />
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M1.5 10.8214C1.5 10.4459 1.80445 10.1414 2.18 10.1414H13.82C14.1956 10.1414 14.5 10.4459 14.5 10.8214C14.5 11.197 14.1956 11.5014 13.82 11.5014H2.18C1.80445 11.5014 1.5 11.197 1.5 10.8214Z"
      fill="#EA6A29"
    />
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M1.5 14.1815C1.5 13.8059 1.80445 13.5015 2.18 13.5015H13.82C14.1956 13.5015 14.5 13.8059 14.5 14.1815C14.5 14.557 14.1956 14.8615 13.82 14.8615H2.18C1.80445 14.8615 1.5 14.557 1.5 14.1815Z"
      fill="#EA6A29"
    />
  </svg>
)

export const InputIcon = () => (
  <svg width="16" height="16" viewBox="0 0 16 16" fill="none" xmlns="http://www.w3.org/2000/svg">
    <path
      d="M9.09097 4.19231V5.57692C9.09097 5.76053 9.01914 5.93663 8.89127 6.06646C8.7634 6.19629 8.58997 6.26923 8.40914 6.26923C8.22831 6.26923 8.05488 6.19629 7.92701 6.06646C7.79915 5.93663 7.72731 5.76053 7.72731 5.57692V4.88462H5.68182V11.1154H7.04548C7.22631 11.1154 7.39974 11.1883 7.52761 11.3182C7.65548 11.448 7.72731 11.6241 7.72731 11.8077C7.72731 11.9913 7.65548 12.1674 7.52761 12.2972C7.39974 12.4271 7.22631 12.5 7.04548 12.5H2.95449C2.77366 12.5 2.60023 12.4271 2.47236 12.2972C2.3445 12.1674 2.27266 11.9913 2.27266 11.8077C2.27266 11.6241 2.3445 11.448 2.47236 11.3182C2.60023 11.1883 2.77366 11.1154 2.95449 11.1154H4.31815V4.88462H2.27266V5.57692C2.27266 5.76053 2.20082 5.93663 2.07296 6.06646C1.94509 6.19629 1.77166 6.26923 1.59083 6.26923C1.41 6.26923 1.23657 6.19629 1.1087 6.06646C0.980833 5.93663 0.908997 5.76053 0.908997 5.57692V4.19231C0.908997 4.0087 0.980833 3.83261 1.1087 3.70277C1.23657 3.57294 1.41 3.5 1.59083 3.5H8.40914C8.58997 3.5 8.7634 3.57294 8.89127 3.70277C9.01914 3.83261 9.09097 4.0087 9.09097 4.19231Z"
      fill="#EA6A29"
    />
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M11.091 2.35001C11.091 1.99103 11.382 1.70001 11.741 1.70001L14.441 1.70001C14.8 1.70001 15.091 1.99103 15.091 2.35001C15.091 2.709 14.8 3.00001 14.441 3.00001L11.741 3.00001C11.382 3.00001 11.091 2.709 11.091 2.35001Z"
      fill="#EA6A29"
    />
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M12.441 13L12.441 3L13.741 3L13.741 13L12.441 13Z"
      fill="#EA6A29"
    />
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M11.091 13.65C11.091 13.291 11.382 13 11.741 13L14.441 13C14.8 13 15.091 13.291 15.091 13.65C15.091 14.009 14.8 14.3 14.441 14.3L11.741 14.3C11.382 14.3 11.091 14.009 11.091 13.65Z"
      fill="#EA6A29"
    />
  </svg>
)

export const ErrorIcon = () => (
  <svg width="16" height="16" viewBox="0 0 16 16" fill="none" xmlns="http://www.w3.org/2000/svg">
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M8.67499 2.5C8.67499 2.1272 8.3728 1.82501 8 1.82501C7.6272 1.82501 7.32501 2.1272 7.32501 2.5V11.15C7.32501 11.5228 7.6272 11.825 8 11.825C8.3728 11.825 8.67499 11.5228 8.67499 11.15V2.5ZM8 14.175C8.3728 14.175 8.67499 13.8728 8.67499 13.5C8.67499 13.1272 8.3728 12.825 8 12.825C7.6272 12.825 7.32501 13.1272 7.32501 13.5C7.32501 13.8728 7.6272 14.175 8 14.175Z"
      fill="#EA6A29"
    />
  </svg>
)

export const BeaconIcon = ({ type }: { type: string }) => {
  if (type === StepTypes.click) {
    return <ClickIcon />
  }

  if (type === StepTypes.dropdownSelect) {
    return <DropdownIcon />
  }

  if (type === StepTypes.input) {
    return <InputIcon />
  }

  return <ErrorIcon />
}
